export const downloadCsv = (name, head, rows) => {
  const esc = (v) => { const s = v === null || v === undefined ? "" : typeof v === "number" ? String(v).replace(".", ",") : String(v).replace(/^([=+\-@\t\r])(?![\d.,\s%€]*$)/, "'$1"); return /[;"\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s; };
  const blob = new Blob(["\ufeff" + [head.map(esc).join(";"), ...rows.map((r) => r.map(esc).join(";"))].join("\n")], { type: "text/csv;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob); a.download = `${name.replace(/[^\w-]+/g, "_")}.csv`; a.click();
};

export const pctFmt = (v, d = 1) => (v === null || v === undefined ? "—" : `${v > 0 ? "+" : ""}${v.toLocaleString("it-IT", { maximumFractionDigits: d })}%`);
export const nfmt = (v, d = 1) => (v ?? 0).toLocaleString("it-IT", { maximumFractionDigits: d, useGrouping: "always" });
